export default __webpack_public_path__ + "8bc11e79ced3cd19d1bc4989b3833030.png";